/**
 * @generated SignedSource<<a606f57013a92ab2b49873c19e572608>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfileScreenEmployeeUploadLinkMutation$variables = Record<PropertyKey, never>;
export type ProfileScreenEmployeeUploadLinkMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
    };
    readonly url: string;
  } | null;
};
export type ProfileScreenEmployeeUploadLinkMutation = {
  response: ProfileScreenEmployeeUploadLinkMutation$data;
  variables: ProfileScreenEmployeeUploadLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UploadImageLinkResponse",
    "kind": "LinkedField",
    "name": "uploadImageLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileScreenEmployeeUploadLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileScreenEmployeeUploadLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c07248ffa6c0d0d834dd29e2a1c32771",
    "id": null,
    "metadata": {},
    "name": "ProfileScreenEmployeeUploadLinkMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileScreenEmployeeUploadLinkMutation {\n  uploadImageLink {\n    image {\n      id\n    }\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "423b677bc105c510e06dbf590dd525e5";

export default node;
